var map = {
	"./2019/brearley.png": "83ec",
	"./2019/brearley.svg": "5af5",
	"./2019/locator.png": "a583",
	"./2019/reindeer-roundup.svg": "fb21",
	"./2019/reindeer2.png": "318b",
	"./2019/reindeer3.png": "e75b",
	"./2020/acorn.png": "df15",
	"./2020/acorns-2.png": "437f",
	"./2020/acorns.png": "3977",
	"./2020/bb-festive-guest.svg": "8ad4",
	"./2020/brearley.png": "fc3e",
	"./2020/brearley.svg": "a196",
	"./2020/trail.jpg": "3435",
	"./2021/SheffBID.png": "b88a",
	"./2021/brearley.png": "021f",
	"./2021/hero.png": "26a2",
	"./2021/sb-logo-white.png": "7129",
	"./2021/snow-floor-big.png": "ec98",
	"./2021/title-block+date.png": "d0f0",
	"./app-store-badge.png": "d06d",
	"./app-store-badge.svg": "7780",
	"./bear.png": "8d99",
	"./bear.svg": "2236",
	"./bear_head.png": "9fd5",
	"./bear_head.svg": "c5d4",
	"./bid.png": "9dab",
	"./bid.svg": "6307",
	"./bidV2-white.svg": "1d12",
	"./bidV2.svg": "fd03",
	"./bookofclues.png": "1ca4",
	"./boy.png": "980c",
	"./boy.svg": "e6b9",
	"./christmastrail.png": "a89e",
	"./christmastrail.svg": "d3d3",
	"./date.svg": "9bcd",
	"./elf.svg": "dbb4",
	"./feet.svg": "80af",
	"./fox.png": "8c54",
	"./fox.svg": "865b",
	"./girl.png": "aedd",
	"./girl.svg": "d06f",
	"./google-play-badge.png": "cd2b",
	"./logo.png": "9d64",
	"./logo.svg": "e347",
	"./mail.png": "e9ce",
	"./mail.svg": "999f",
	"./old/bear.svg": "eb26",
	"./old/elf.svg": "7d4d",
	"./old/fox.svg": "4b5e",
	"./old/owl.svg": "2dd8",
	"./old/santa.svg": "4abc",
	"./owl.png": "0088",
	"./owl.svg": "ff3a",
	"./santa.png": "eeb0",
	"./santa.svg": "7aed",
	"./texture_1920.jpg": "e450",
	"./texture_3840.jpg": "f7c5",
	"./texture_480.jpg": "28ea",
	"./texture_960.jpg": "b791",
	"./texture_green_3840.jpg": "dbc5",
	"./texture_green_alt_3840.jpg": "1862",
	"./texture_red_3840.jpg": "4861"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";